/**
 * Campaign Generation — types
 *
 * Sprint 5 · Project Symphony
 *
 * Mirrors the /generation payload. No AI vocabulary — the customer
 * sees departments and states, never providers or models.
 */
export type TaskStatusCode =
  | "queued"
  | "generating"
  | "review_ready"
  | "attention_required"
  | "skipped";

export interface GenerationGroupCounts {
  queued: number;
  generating: number;
  review_ready: number;
  attention_required: number;
  skipped: number;
  total: number;
}

export type DepartmentSubstateCode =
  // Content Team
  | "waiting"
  | "receiving_assignment"
  | "planning_deliverables"
  | "preparing_content_queue"
  | "complete"
  // Creative Studio
  | "preparing_assets"
  | "generating_images"
  | "generating_voice"
  | "generating_video"
  | "review_ready"
  // Publishing Team
  | "receiving_deliverables"
  | "awaiting_approval";

export interface GenerationState {
  progress_pct: number;
  totals: {
    total: number;
    queued: number;
    generating: number;
    review_ready: number;
    attention_required: number;
    skipped: number;
    completed: number;
  };
  groups: Record<string, GenerationGroupCounts>;
  department_substates: Record<
    "content_team" | "creative_studio" | "publishing_team",
    { substate: DepartmentSubstateCode }
  >;
  is_active: boolean;
  generation_completed_at: string | null;
}

export interface BeginProductionPayload {
  heygen?: boolean;
  runway?: boolean;
}

/** Customer-facing substate labels. No AI vocabulary. */
export const SUBSTATE_LABEL: Record<DepartmentSubstateCode, string> = {
  waiting: "Waiting",
  receiving_assignment: "Receiving assignment",
  planning_deliverables: "Planning deliverables",
  preparing_content_queue: "Preparing content queue",
  complete: "Complete",
  preparing_assets: "Preparing assets",
  generating_images: "Producing images",
  generating_voice: "Producing voiceovers",
  generating_video: "Producing video",
  review_ready: "Review ready",
  receiving_deliverables: "Receiving deliverables",
  awaiting_approval: "Awaiting approval",
};
